module.exports = __webpack_public_path__ + "img/mercedes-benz-logo.9fbdbfee.jpg";